
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, ArchiveIcon, ArchiveRestore } from "lucide-react";

interface ArchiveRestoreActionsProps {
  isArchived: boolean;
  onRestore: () => void;
  onArchive: () => void;
  restorePending: boolean;
  archivePending: boolean;
}

const ArchiveRestoreActions = ({
  isArchived,
  onRestore,
  onArchive,
  restorePending,
  archivePending
}: ArchiveRestoreActionsProps) => {
  return isArchived ? (
    <Button 
      type="button" 
      variant="outline" 
      onClick={onRestore}
      disabled={restorePending}
    >
      {restorePending ? (
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
      ) : (
        <ArchiveRestore className="h-4 w-4 mr-2" />
      )}
      Herstellen
    </Button>
  ) : (
    <Button 
      type="button" 
      variant="outline" 
      onClick={onArchive}
      disabled={archivePending}
    >
      {archivePending ? (
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
      ) : (
        <ArchiveIcon className="h-4 w-4 mr-2" />
      )}
      Archiveren
    </Button>
  );
};

export default ArchiveRestoreActions;
